import React from 'react';
import { styled, TablePagination } from '@mui/material';
import { Colors } from 'library';

interface RTablePaginationProps {
    count: number;
    perPage: number;
    page: number;
    onPageChange: (page: number) => void;
}

export function RTablePagination({ count, perPage, page, onPageChange }: RTablePaginationProps) {
    if (count <= perPage) return null;

    return (
        <PaginationRow>
            <TablePagination
                component="div"
                count={count}
                rowsPerPage={perPage}
                page={page - 1}
                onPageChange={(_, newPage) => onPageChange(newPage + 1)}
                rowsPerPageOptions={[]}
            />
        </PaginationRow>
    );
}

const PaginationRow = styled('div')({
    display: 'flex',
    justifyContent: 'flex-end',
    '& .MuiTablePagination-toolbar': {
        minHeight: 48,
        alignItems: 'center',
    },
    '& .MuiTablePagination-displayedRows': {
        fontSize: 13,
        color: Colors.mediumGrey,
        margin: 0,
    },
    '& .MuiTablePagination-actions': {
        display: 'flex',
        alignItems: 'center',
    },
    '& .MuiTablePagination-actions button': {
        color: Colors.mediumGrey,
    },
    '& .MuiTablePagination-actions button.Mui-disabled': {
        color: Colors.lightGrey,
    },
});
